import { TRACKING_PREFIX } from '../consts'
import { TrackingEvent } from '../types'

export const trackEvent = (event: TrackingEvent) => {
  if (window?.heap?.loaded && window.heap.track) {
    const eventName = TRACKING_PREFIX + event.name
    window.heap.track(eventName, event.properties)
  }
}
